var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-footer-full",staticStyle:{"background-color":"white","padding":"15px"}},[_c('span',{staticClass:"footer-text",staticStyle:{"margin-right":"5px","background-color":"white"}},[_vm._v(" "+_vm._s(_vm.$t('copyright'))+" "),_c('a',{attrs:{"href":"https://propulsoft.ca/"}},[_vm._v(" Propulsoft.ca")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }